<label class="label">{{ label }}</label>
<div class="start-center flex-row mat-body-2">
    @if (!contentRef?.innerHTML?.trim()) {
        <span cbEllipsis="applyEllipsis"
              [ngClass]="!applyEllipsis ? 'content' : 'truncate-content'"
              class="mat-body-2"
        >{{ value | cbDasher }}</span>
    }
    @if (showBtn && btnCondition !== false) {
        <button
            mat-icon-button
            (click)="handleClick($event)"
            class="cb-grey">
            <mat-icon>{{ btnIcon != null ? btnIcon : 'pageview' }}</mat-icon>
        </button>
    }
</div>
<div cbEllipsis="applyEllipsis" class="mat-body-2"
     #contentRef>
    <ng-content [ngClass]="!applyEllipsis ? 'content' : 'truncate-content'"
    ></ng-content>
</div>
